import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { OnboardingRegistrationStatus } from '@/common/viewModels/Enums';
import { RegistrationDetailsOdinRefresh } from '@/common/viewModels';
import { Button } from '@/external/telstra-ui-vue/components';

@Component({
  components: {
    Button,
  },
})
export default class TenantDetailsNav extends Vue {
  @Prop({required: true}) isLoading!: boolean;

  @Emit()
  onEdit() {
    this.$emit('action', 'edit');
  }

  @Emit()
  onClose() {
    this.$emit('action', 'close');
  }

}
